import type { RouteRecordRaw } from 'vue-router';

import { getFacebookRoutes } from '@/features/facebook/routes';

import getAffiliateNetworksRoutes from '../features/affiliate-networks/getAffiliateNetworksRoutes';
import getAuthenticationRoutes from '../features/authentication/getAuthenticationRoutes';
import getCampaignsRoutes from '../features/campaigns/getCampaignsRoutes';
import getFilesRoutes from '../features/files/getFilesRoutes';
import getLandingsRoutes from '../features/landings/getLandingsRoutes';
import getMonitorRoutes from '../features/monitor/getMonitorRoutes';
import getOffersRoutes from '../features/offers/getOffersRoutes';
import getReportRoutes from '../features/report/report-page/getReportRoutes';
import getRotationsRoutes from '../features/rotations/getRotationsRoutes';
import getSettingsRoutes from '../features/settings/getSettingsRoutes';
import getTrafficSourcesRoutes from '../features/traffic-sources/getTrafficSourcesRoutes';
import getTrendsRoutes from '../features/trends/getTrendsRoutes';
import getTriggersRoutes from '../features/triggers/getTriggersRoutes';
import getUsersRoutes from '../features/users/getUsersRoutes';

const StubPage = async () => import('../pages/StubPage.vue');
const PageNotFound = async () => import('../pages/PageNotFound.vue');
const GroupsPage = async () => import('../pages/GroupsPage.vue');
const DomainsPage = async () => import('../pages/DomainsPage.vue');
const ClicklogPage = async () => import('../pages/ClicklogPage.vue');
const ConversionsPage = async () => import('../pages/ConversionsPage.vue');
const UpdatePage = async () => import('../pages/update/UpdatePage.vue');
const RollbackPage = async () => import('../pages/rollback/RollbackPage.vue');

export default function getRoutes(): RouteRecordRaw[] {
  return [
    {
      component: PageNotFound,
      meta: {
        title: '404 Not found',
      },
      name: '404',
      path: '/404',
    },
    ...getCampaignsRoutes(),
    ...getRotationsRoutes(),
    ...getReportRoutes(),
    ...getAuthenticationRoutes(),
    ...getUsersRoutes(),
    ...getMonitorRoutes(),
    ...getAffiliateNetworksRoutes(),
    ...getOffersRoutes(),
    ...getLandingsRoutes(),
    ...getTrafficSourcesRoutes(),
    ...getTrendsRoutes(),
    ...getFilesRoutes(),
    ...getSettingsRoutes(),
    ...getFacebookRoutes(),
    {
      component: ConversionsPage,
      meta: {
        title: 'Conversions',
        useIn: ['navigation-tabs'],
      },
      name: 'conversions',
      path: '/conversions',
    },
    {
      component: ClicklogPage,
      meta: {
        title: 'Clicklog',
        useIn: ['navigation-tabs'],
      },
      name: 'clicklog',
      path: '/clicklog',
    },
    ...getTriggersRoutes(),
    {
      component: StubPage,
      meta: {
        title: 'Update',
        useIn: ['menu'],
      },
      name: 'update',
      path: '/update',
    },
    {
      component: DomainsPage,
      meta: {
        title: 'Domains',
        useIn: ['menu'],
      },
      name: 'domains',
      path: '/domains',
    },
    {
      component: GroupsPage,
      meta: {
        title: 'Groups',
        useIn: ['menu'],
      },
      name: 'groups',
      path: '/groups',
    },
    {
      component: UpdatePage,
      meta: {
        title: 'Update',
        useIn: ['menu'],
      },
      name: 'update',
      path: '/update',
    },
    {
      component: RollbackPage,
      meta: {
        title: 'Rollback',
        useIn: ['menu'],
      },
      name: 'rollback',
      path: '/rollback',
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404',
    },
  ];
}
